
/* GRAPESJS Specific stylesheets */
import BreakingNewsGrapesJsStyle from '!!raw-loader!./BreakingNewsGrapeJs.css';
import grid from '!!raw-loader!./grid.css';
import list from '!!raw-loader!./list.module.css';
import footerStyles from '!!raw-loader!./footer.css';
import headerStyles from '!!raw-loader!./header.css';
import MainMenuStyles from '!!raw-loader!./mainMenu.css';
import SideDrawerStyles from '!!raw-loader!./drawerComponent.css';
import BreadCrumbsStyles from '!!raw-loader!./breadCrumbs.css';
import HeroLayoutStyles from '!!raw-loader!./Herolayout.css';
import AuthorShowStyles from '!!raw-loader!./authorShow.css';
import VideoShowStyles from '!!raw-loader!./videoShow.css';
import PageNotFoundStyles from '!!raw-loader!./error.css';
import IndexStyle from '!!raw-loader!../../../src/index.css';
import ArabicLang from '!!raw-loader!../../../src/arabicLang.css';
import MuiStyle from '!!raw-loader!../../../src/ui.css';
import LayoutStyles from '!!raw-loader!./layout.css';
import articleShowStyles from '!!raw-loader!./articleShow.css';
import SlideShowStyles from '!!raw-loader!./slideShow.css';
import SocialShare from '!!raw-loader!./socialShare.css';
import StaticComponentStyle from '!!raw-loader!./StaticComponent.css';
import WebStoriesStyle from '!!raw-loader!./webstories.css';
import PaginationStyle from '!!raw-loader!./pagination.css';
import SocialShareTwoStyle from '!!raw-loader!./SocialShareTwo.css';
import PaginationTwoStyle from '!!raw-loader!./paginationTwo.css';
import BreakingNewsTwoStyle from '!!raw-loader!./BreakingNewsTwo.css';
import VideoCarouselStyle from '!!raw-loader!./VideoCarousel.css';
import VideoCarouselCenterStyle from '!!raw-loader!./VideoCarouselCenter.css';
import BreakingNewsTickerStyle from '!!raw-loader!./BreakingNewsTicker.css';
import QuickViewTwoStyle from '!!raw-loader!./QuickViewTwo.css';
import ListViewTwoStyle from '!!raw-loader!./ListViewTwo.css';
import ListViewAltStyle from '!!raw-loader!./ListViewAlt.css';
import HomeGridViewTwoStyle from '!!raw-loader!./HomeGridViewTwo.css';
import WebStoriesTwoStyle from '!!raw-loader!./WebStoriesTwo.css';
import VideoReelStyle from '!!raw-loader!./VideoReel.css';
import HeroLayoutTwoStyle from '!!raw-loader!./HeroLayoutTwo.css';
import HeroLayoutInvertedStyle from '!!raw-loader!./HeroLayoutInverted.css';
import HeroLayoutHrTwoStyle from '!!raw-loader!./HeroLayoutHrTwo.css';
import RhsHomeTwoStyle from '!!raw-loader!./RhsHomeTwo.css';
import HomeCardListStyle from '!!raw-loader!./HomeCardList.css';
import NewsSocialFeedStyle from '!!raw-loader!./NewsSocialFeed.css';
import NewsSocialFeedV2Style from '!!raw-loader!./NewsSocialFeedV2.css';
import MainMenuFourStyle from '!!raw-loader!./MainMenuFour.css';
import WebstoriesListFourStyle from '!!raw-loader!./WebstoriesList.css';
import ContentTagsListStyle from '!!raw-loader!./ContentTagsList.css';
import PollCardStyle from '!!raw-loader!./PollCard.css';
import DynamicListStyle from '!!raw-loader!./DynamicList.css';
import HeaderFourStyle from '!!raw-loader!./HeaderFour.css';
import QuizListFourStyle from '!!raw-loader!./QuizListFour.css';
import QuizCardFourStyle from '!!raw-loader!./QuizCardFour.css';
import QuizRelatedFourStyle from '!!raw-loader!./QuizRelatedFour.css';
import QuizShowFourStyle from '!!raw-loader!./QuizShowFourPanels.css';
import RhsHomeOtherTwoStyle from '!!raw-loader!./RhsHomeOtherTwo.css';
import GridViewTwoStyle from '!!raw-loader!./GridViewTwo.css';
import WebStoriesListTwoStyle from '!!raw-loader!./WebStoriesListTwo.css';
import MediaListTwoStyle from '!!raw-loader!./MediaListTwo.css';
import PhotoListTwoStyle from '!!raw-loader!./PhotoListTwo.css';
import ArticleShowTwoStyle from '!!raw-loader!./ArticleShowTwo.css';
import ArticleShowFourStyle from '!!raw-loader!./ArticleShowFour.css';
import ArticleShowFourLeadStyle from '!!raw-loader!./LeadImageArticleShow.css';
import ArticleShowFourLeadMediaStyle from '!!raw-loader!./LeadImageOrVideo.css';
import ArticleShowFourMetaCard from "!raw-loader!./MetaCard.css";

import ArticleShowFourImageStyle from '!!raw-loader!./Image.css';
import ArticleShowFourAuthorStyle from '!!raw-loader!./AuthorCard.css';
import ArticleShowFourAuthorTwoStyle from '!!raw-loader!./AuthorCard2.css';
import ArticleShowFourAdStyle from '!!raw-loader!./AdInsert.css';
import ArticleShowFourEmbedStyle from '!!raw-loader!./SocialEmbed.css';
import liveBlogStyle from '!!raw-loader!./liveBlog.css';
import VideoShowTwoStyle from '!!raw-loader!./VideoShowTwo.css';
import SlideShowTwoStyle from '!!raw-loader!./SlideShowTwo.css';
import FooterTwoStyle from '!!raw-loader!./FooterTwo.css';
import HeaderTwoStyle from '!!raw-loader!./HeaderTwo.css';
import RhsWightStyle from '!!raw-loader!./RhsWight.css';
// import otherHeaderStyle from '!!raw-loader!./otherHeader.css';
import MainMenuTwoStyles from '!!raw-loader!./MainMenuTwo.css';
// import otherSidebarStyles from '!!raw-loader!./otherSidebar.css';
// import otherMainMenuStyles from '!!raw-loader!./otherMainMenu.css';
import AuthorShowTwoStyles from '!!raw-loader!./AuthorShowTwo.css';
import StaticPageTwoStyles from '!!raw-loader!./StaticPageTwo.css';
import PageNotFoundTwoStyles from '!!raw-loader!./PageNotFoundTwo.css';
import ContentRestrictionsTwoStyles from '!!raw-loader!./ContentRestrictionsTwo.css';
import DrawerComponentTwoStyles from '!!raw-loader!./DrawerComponentTwo.css';
import BreadCrumbsTwoStyles from '!!raw-loader!./BreadCrumbsTwo.css';
import PodcastTwoStyle from '!!raw-loader!./PodcastTwo.css';
import HorizontalListFourStyle from '!!raw-loader!./HorizontalListFour.css';
import VerticalListFourStyle from '!!raw-loader!./VerticalListFour.css';
import CardVariant1Style from '!!raw-loader!./CardVariant1.css';
/*------ theme three styles ---------*/
import SocialShareThreeStyle from '!!raw-loader!./SocialShareThree.css';
import PaginationThreeStyle from '!!raw-loader!./PaginationThree.css';
import BreakingNewsThreeStyle from '!!raw-loader!./BreakingNewsThree.css';
import BreakingNewsThreeTickerStyle from '!!raw-loader!./BreakingNewsThreeTicker.css';
import QuickViewThreeStyle from '!!raw-loader!./QuickViewThree.css';
import ListViewThreeStyle from '!!raw-loader!./ListViewThree.css';
import HomeGridViewThreeStyle from '!!raw-loader!./HomeGridViewThree.css';
import WebStoriesThreeStyle from '!!raw-loader!./WebStoriesThree.css';
import HeroLayoutThreeStyle from '!!raw-loader!./HeroLayoutThree.css';
import HeroLayoutHrThreeStyle from '!!raw-loader!./HeroLayoutHrThree.css';
import RhsHomeThreeStyle from '!!raw-loader!./RhsHomeThree.css';
import RhsHomeOtherThreeStyle from '!!raw-loader!./RhsHomeOtherThree.css';
import GridViewThreeStyle from '!!raw-loader!./GridViewThree.css';
import WebStoriesListThreeStyle from '!!raw-loader!./WebStoriesListThree.css';
import MediaListThreeStyle from '!!raw-loader!./MediaListThree.css';
import PhotoListThreeStyle from '!!raw-loader!./PhotoListThree.css';
import HomePhotoGalleryStyle from '!!raw-loader!./HomePhotoGallery.css';
import HomeWebStoriesStyle from '!!raw-loader!./HomeWebStories.css';
import ArticleShowThreeStyle from '!!raw-loader!./ArticleShowThree.css';
import QuizShowStyle from '!!raw-loader!./QuizShow.css';
import SurveyShowStyle from '!!raw-loader!./SurveyShow.css';
import VideoShowThreeStyle from '!!raw-loader!./VideoShowThree.css';
import SlideShowThreeStyle from '!!raw-loader!./SlideShowThree.css';
import FooterThreeStyle from '!!raw-loader!./FooterThree.css';
import HeaderThreeStyle from '!!raw-loader!./HeaderThree.css';
import HeaderOtherStyle from '!!raw-loader!./HeaderOther.css';
import OtherMainMenuThreeStyle from '!!raw-loader!./OtherMainMenuThree.css';
import otherDrawerComponentThreeStyle from '!!raw-loader!./otherDrawerComponentThree.css';
import HomeHeaderThreeStyle from '!!raw-loader!./HomeHeaderThree.css';
import HeroLayoutwithHeaderStyles from '!!raw-loader!./HeroLayoutwithHeader.css';
import MainMenuThreeStyles from '!!raw-loader!./MainMenuThree.css';
import AuthorShowThreeStyles from '!!raw-loader!./AuthorShowThree.css';
import StaticPageThreeStyles from '!!raw-loader!./StaticPageThree.css';
import PageNotFoundThreeStyles from '!!raw-loader!./PageNotFoundThree.css';
import DrawerComponentThreeStyles from '!!raw-loader!./DrawerComponentThree.css';
import BreadCrumbsThreeStyles from '!!raw-loader!./BreadCrumbsThree.css';
import PodcastThreeStyle from '!!raw-loader!./PodcastThree.css';
import HomeFaqStyle from '!!raw-loader!./HomeFaq.css';
import FaqListStyle from '!!raw-loader!./FaqList.css';
import FourLinksStyle from '!!raw-loader!./FourLinks.css';
import OtherListViewStyle from '!!raw-loader!./OtherListView.css';
import ExpertsStyle from '!!raw-loader!./Experts.css';
import DynamicFormStyle from '!!raw-loader!./DynamicForm.css';
/*------ theme three styles ---------*/
/*------ Amp styles ---------*/
import headerAmpStyles from '!!raw-loader!./headerAmp.css';
import MainMenuAmpStyles from '!!raw-loader!./mainMenuAmp.css';
import articleShowAmpStyles from '!!raw-loader!./articleShowAmp.css';
import SideDrawerAmpStyles from '!!raw-loader!./drawerComponentAmp.css';
import footerAmpStyles from '!!raw-loader!./footerAmp.css';
import BreadCrumbsAmpStyles from '!!raw-loader!./breadCrumbsAmp.css';
import BreadCrumbsTwoAmpStyles from '!!raw-loader!./BreadCrumbsTwoAmp.css';
import ArticleShowTwoAmpStyles from '!!raw-loader!./ArticleShowTwoAmp.css';
import HeaderTwoAmpStyles from '!!raw-loader!./HeaderTwoAmp.css';
import FooterTwoAmpStyles from '!!raw-loader!./FooterTwoAmp.css';
import MainMenuTwoAmpStyles from '!!raw-loader!./MainMenuTwoAmp.css';
import DrawerComponentTwoAmpStyles from '!!raw-loader!./DrawerComponentTwoAmp.css';
import PhotoShowTwoAmpStyles from '!!raw-loader!./PhotoShowTwoAmp.css';
import VideoShowTwoAmpStyles from '!!raw-loader!./VideoShowTwoAmp.css';
import ampLiveBlogStyles from '!!raw-loader!./ampLiveBlog.css';

/*------ Amp styles ---------*/

/*----Theme Three-- Amp styles ---------*/
import ArticleShowThreeAmpStyles from '!!raw-loader!./ArticleShowThreeAmp.css';
import HeaderThreeAmpStyles from '!!raw-loader!./HeaderThreeAmp.css';
import FooterThreeAmpStyles from '!!raw-loader!./FooterThreeAmp.css';
import BreadCrumbsThreeAmpStyles from '!!raw-loader!./BreadCrumbsThreeAmp.css';
import MainMenuThreeAmpStyles from '!!raw-loader!./MainMenuThreeAmp.css';
import DrawerComponentThreeAmpStyles from '!!raw-loader!./DrawerComponentThreeAmp.css';
import PhotoShowThreeAmpStyles from '!!raw-loader!./PhotoShowThreeAmp.css';
import VideoShowThreeAmpStyles from '!!raw-loader!./VideoShowThreeAmp.css';
/*----Theme Three-- Amp styles ---------*/


export const STYLES = {
    "BreakingNews": [BreakingNewsGrapesJsStyle, IndexStyle, MuiStyle],
    "CarouselCardBlock": [grid],
    "GridView": [grid, PaginationStyle],
    "ListView": [list, footerStyles, PaginationStyle],
    "Header": [headerStyles, MainMenuStyles, SideDrawerStyles, IndexStyle, MuiStyle],
    "Footer": [footerStyles],
    "BreadCrumbs": [BreadCrumbsStyles],
    "HeroLayout": [HeroLayoutStyles],
    "AuthorShow": [AuthorShowStyles, SocialShare],
    "VideoShow": [VideoShowStyles, SocialShare],
    "PageNotFound": [PageNotFoundStyles],
    "PageGone": [PageNotFoundStyles],
    "ArticleShow": [articleShowStyles, SocialShare, AuthorShowStyles],
    "SlideShow": [SlideShowStyles, SocialShare],
    "GlobalSettingComponent": [LayoutStyles],
    "GlobalSettingComp": [IndexStyle, MuiStyle],
    "GLOBALSTYLES": [IndexStyle, MuiStyle],
    "StaticPage": [StaticComponentStyle],
    "WebStories": [WebStoriesStyle],
    "HomeGridViewTwo": [HomeGridViewTwoStyle, IndexStyle, MuiStyle, ArabicLang],
    "BreakingNewsTwo": [BreakingNewsTwoStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "VideoCarousel": [VideoCarouselStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "VideoCarouselCenter": [VideoCarouselCenterStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "BreakingNewsTicker": [BreakingNewsTickerStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "QuickViewTwo": [QuickViewTwoStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "WebStoriesTwo": [WebStoriesTwoStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "VideoReel": [VideoReelStyle, IndexStyle, BreakingNewsGrapesJsStyle, MuiStyle, ArabicLang],
    "HeroLayoutTwo": [HeroLayoutTwoStyle, IndexStyle, MuiStyle, ArabicLang],
    "HeroLayoutInverted": [HeroLayoutInvertedStyle, IndexStyle, MuiStyle, ArabicLang],
    "HeroLayoutHrTwo": [HeroLayoutHrTwoStyle, IndexStyle, MuiStyle, ArabicLang],
    "RhsHomeTwo": [RhsHomeTwoStyle, IndexStyle, MuiStyle, ArabicLang],
    "HomeCardList": [HomeCardListStyle, IndexStyle, MuiStyle, ArabicLang],
    "NewsSocialFeed": [NewsSocialFeedStyle, IndexStyle, MuiStyle, ArabicLang],
    "NewsSocialFeedV2": [NewsSocialFeedStyle, NewsSocialFeedV2Style, IndexStyle, MuiStyle, ArabicLang],
    "MainMenuFour": [MainMenuFourStyle, IndexStyle, MuiStyle, ArabicLang],
    "WebstoriesListFour": [WebstoriesListFourStyle, IndexStyle, MuiStyle, ArabicLang],
    "ContentTagsList": [ContentTagsListStyle, IndexStyle, MuiStyle, ArabicLang],
    "PollCard": [PollCardStyle, IndexStyle, MuiStyle, ArabicLang],
    "DynamicList": [DynamicListStyle, IndexStyle, MuiStyle, ArabicLang],
    "QuizListFour": [QuizListFourStyle, QuizCardFourStyle, IndexStyle, MuiStyle, ArabicLang],
    "QuizShowFour": [QuizShowFourStyle, IndexStyle, MuiStyle, ArabicLang],
    "QuizRelatedFour": [QuizRelatedFourStyle, QuizCardFourStyle, IndexStyle, MuiStyle, ArabicLang],
    "HeaderFour": [HeaderFourStyle, MainMenuFourStyle, IndexStyle, MuiStyle, ArabicLang],
    "RhsHomeOtherTwo": [RhsHomeOtherTwoStyle, IndexStyle, MuiStyle, ArabicLang],
    "GridViewTwo": [GridViewTwoStyle, IndexStyle, PaginationTwoStyle, MuiStyle, ArabicLang],
    "WebStoriesListTwo": [WebStoriesListTwoStyle, IndexStyle, PaginationTwoStyle, MuiStyle, ArabicLang],
    "MediaListTwo": [MediaListTwoStyle, IndexStyle, PaginationTwoStyle, MuiStyle, ArabicLang],
    "PhotoListTwo": [PhotoListTwoStyle, IndexStyle, PaginationTwoStyle, MuiStyle, ArabicLang],
    "ArticleShowTwo": [ArticleShowTwoStyle, IndexStyle, SocialShareTwoStyle, AuthorShowTwoStyles, MuiStyle, ArabicLang],
    "ArticleShowFour": [ArticleShowFourMetaCard, ArticleShowFourStyle, ArticleShowFourLeadStyle, ArticleShowFourLeadMediaStyle, ArticleShowFourImageStyle, ArticleShowFourAuthorStyle, ArticleShowFourAuthorTwoStyle, ArticleShowFourAdStyle, ArticleShowFourEmbedStyle, IndexStyle, MuiStyle, ArabicLang],
    "LeadImageArticleShow": [ArticleShowFourStyle, ArticleShowFourLeadStyle, ArticleShowFourLeadMediaStyle, ArticleShowFourImageStyle, ArticleShowFourAuthorStyle, ArticleShowFourAuthorTwoStyle, ArticleShowFourAdStyle, ArticleShowFourEmbedStyle, IndexStyle, MuiStyle, ArabicLang],
    "liveBlog": [liveBlogStyle, IndexStyle, MuiStyle, ArabicLang],
    "PodcastTwo": [PodcastTwoStyle, IndexStyle, SocialShareTwoStyle, AuthorShowTwoStyles, MuiStyle, ArabicLang],
    "HorizontalListFour": [HorizontalListFourStyle, CardVariant1Style, IndexStyle, MuiStyle, ArabicLang],
    "VerticalListFour": [VerticalListFourStyle, CardVariant1Style, IndexStyle, MuiStyle, ArabicLang],
    "VideoShowTwo": [VideoShowTwoStyle, IndexStyle, SocialShareTwoStyle, AuthorShowTwoStyles, MuiStyle, ArabicLang],
    "SlideShowTwo": [SlideShowTwoStyle, IndexStyle, SocialShareTwoStyle, AuthorShowTwoStyles, MuiStyle, ArabicLang],
    "FooterTwo": [FooterTwoStyle, IndexStyle, MuiStyle, ArabicLang],
    "HeaderTwo": [HeaderTwoStyle, MainMenuTwoStyles, DrawerComponentTwoStyles, ArabicLang],
    // "otherHeader":[otherHeaderStyle, otherMainMenuStyles, otherSidebarStyles,IndexStyle],
    "ListViewTwo": [ListViewTwoStyle, IndexStyle, PaginationTwoStyle, MuiStyle, ArabicLang],
    "ListViewAlt": [ListViewAltStyle, IndexStyle, PaginationTwoStyle, MuiStyle, ArabicLang],
    "BreadCrumbsTwo": [BreadCrumbsTwoStyles, ArabicLang],
    "AuthorShowTwo": [AuthorShowTwoStyles, SocialShareTwoStyle, ArabicLang],
    "StaticPageTwo": [StaticPageTwoStyles, PaginationTwoStyle, ArabicLang],
    "PageNotFoundTwo": [PageNotFoundTwoStyles, ArabicLang],
    "PageGoneTwo": [PageNotFoundTwoStyles, ArabicLang],
    "ContentRestrictionsTwo": [ContentRestrictionsTwoStyles, ArabicLang],
    "RhsWight": [RhsWightStyle, IndexStyle, MuiStyle, ArabicLang],

    /*------ theme three styles ---------*/
    "AuthorShowThree": [AuthorShowThreeStyles, SocialShareThreeStyle, IndexStyle, MuiStyle],
    "ArticleShowThree": [ArticleShowThreeStyle, SocialShareThreeStyle, IndexStyle, AuthorShowThreeStyles, MuiStyle],
    "QuizShow": [QuizShowStyle, SocialShareThreeStyle, IndexStyle, MuiStyle],
    "SurveyShow": [SurveyShowStyle, SocialShareThreeStyle, IndexStyle, MuiStyle],
    "BreakingNewsThree": [BreakingNewsThreeStyle, IndexStyle, MuiStyle],
    "BreakingNewsThreeTicker": [BreakingNewsThreeTickerStyle, IndexStyle, MuiStyle],
    "BreadCrumbsThree": [BreadCrumbsThreeStyles, IndexStyle, MuiStyle],
    "DrawerComponentThree": [DrawerComponentThreeStyles, IndexStyle, MuiStyle],
    "FooterThree": [FooterThreeStyle, SocialShareThreeStyle, IndexStyle, MuiStyle],
    "GridViewThree": [GridViewThreeStyle, IndexStyle, MuiStyle],
    "HeaderThree": [HeaderThreeStyle, MainMenuThreeStyles, DrawerComponentThreeStyles, IndexStyle, HeaderOtherStyle, OtherMainMenuThreeStyle, otherDrawerComponentThreeStyle, MuiStyle],
    "HeroLayoutwithHeader": [HeroLayoutwithHeaderStyles, MainMenuThreeStyles, DrawerComponentThreeStyles, IndexStyle, MuiStyle],

    "HomeHeaderThree": [HomeHeaderThreeStyle, MainMenuThreeStyles, DrawerComponentThreeStyles, IndexStyle, MuiStyle],
    "HomeGridViewThree": [HomeGridViewThreeStyle, IndexStyle, MuiStyle],
    "HeroLayoutThree": [HeroLayoutThreeStyle, IndexStyle, MuiStyle],
    "HeroLayoutHrThree": [HeroLayoutHrThreeStyle, IndexStyle, MuiStyle],
    "ListViewThree": [ListViewThreeStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "MainMenuThree": [MainMenuThreeStyles, IndexStyle, MuiStyle],
    "MediaListThree": [MediaListThreeStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "PaginationThree": [PaginationThreeStyle, IndexStyle, MuiStyle],
    "PageNotFoundThree": [PageNotFoundThreeStyles, IndexStyle, MuiStyle],
    "PageGoneThree": [PageNotFoundThreeStyles, IndexStyle, MuiStyle],
    "PhotoListThree": [PhotoListThreeStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "HomePhotoGallery": [HomePhotoGalleryStyle, IndexStyle, MuiStyle],
    "HomeWebStories": [HomeWebStoriesStyle, IndexStyle, MuiStyle],
    "PodcastThree": [PodcastThreeStyle, IndexStyle, MuiStyle],
    "RhsHomeThree": [RhsHomeThreeStyle, IndexStyle, MuiStyle],
    "RhsHomeOtherThree": [RhsHomeOtherThreeStyle, IndexStyle, MuiStyle],
    "QuickViewThree": [QuickViewThreeStyle, IndexStyle, MuiStyle],
    "SocialShareThree": [SocialShareThreeStyle, IndexStyle, MuiStyle],
    "SlideShowThree": [SlideShowThreeStyle, IndexStyle, MuiStyle],
    "StaticPageThree": [StaticPageThreeStyles, IndexStyle, MuiStyle],
    "WebStoriesThree": [WebStoriesThreeStyle, IndexStyle, MuiStyle],
    "WebStoriesListThree": [WebStoriesListThreeStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "VideoShowThree": [VideoShowThreeStyle, IndexStyle, SocialShareThreeStyle, MuiStyle],
    "FourLinks": [FourLinksStyle, IndexStyle, MuiStyle],
    "HomeFaq": [HomeFaqStyle, IndexStyle, MuiStyle],
    "FaqList": [FaqListStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "OtherListView": [OtherListViewStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "Experts": [ExpertsStyle, PaginationThreeStyle, IndexStyle, MuiStyle],
    "DynamicForm": [DynamicFormStyle, MuiStyle],

    /*------ theme three styles ---------*/

    /*------ amp styles ---------*/

    "HeaderAmp": [headerAmpStyles, MainMenuAmpStyles, SideDrawerAmpStyles, IndexStyle, MuiStyle],
    "FooterAmp": [footerAmpStyles],
    "BreadCrumbsAmp": [BreadCrumbsAmpStyles],
    "ArticleShowAmp": [articleShowAmpStyles, SocialShare],
    "ArticleShowTwoAmp": [ArticleShowTwoAmpStyles, SocialShare, AuthorShowTwoStyles, ArabicLang],
    "HeaderTwoAmp": [HeaderTwoAmpStyles, SocialShare, MainMenuTwoAmpStyles, DrawerComponentTwoAmpStyles, IndexStyle, MuiStyle, ArabicLang],
    "FooterTwoAmp": [FooterTwoAmpStyles, SocialShare, ArabicLang],
    "BreadCrumbsTwoAmp": [BreadCrumbsTwoAmpStyles, ArabicLang],
    "PhotoShowTwoAmp": [PhotoShowTwoAmpStyles, SocialShareTwoStyle, AuthorShowTwoStyles, ArabicLang],
    "VideoShowTwoAmp": [VideoShowTwoAmpStyles, SocialShareTwoStyle, AuthorShowTwoStyles, ArabicLang],
    "ampLiveBlog": [ampLiveBlogStyles, ArabicLang],
    // "MainMenuTwoAmp":[MainMenuTwoAmpStyles,SocialShare],
    // "DrawerComponentTwoAmp":[DrawerComponentTwoAmpStyles,SocialShare]
    /*----Theme Three-- Amp styles ---------*/
    "ArticleShowThreeAmp": [ArticleShowThreeAmpStyles, IndexStyle, SocialShare, MuiStyle],
    "HeaderThreeAmp": [HeaderTwoAmpStyles, HeaderThreeAmpStyles, IndexStyle, MainMenuThreeAmpStyles, DrawerComponentThreeAmpStyles, SocialShare, MuiStyle],
    "FooterThreeAmp": [FooterThreeAmpStyles, IndexStyle, SocialShare, MuiStyle],
    "BreadCrumbsThreeAmp": [BreadCrumbsThreeAmpStyles, IndexStyle, MuiStyle],
    // "MainMenuThreeAmp":[MainMenuThreeAmpStyles, IndexStyle],
    // "DrawerComponentThreeAmp":[DrawerComponentThreeAmpStyles, IndexStyle],
    "PhotoShowThreeAmp": [PhotoShowThreeAmpStyles, IndexStyle, MuiStyle],
    "VideoShowThreeAmp": [VideoShowThreeAmpStyles, IndexStyle, MuiStyle],
    /*----Theme Three-- Amp styles ---------*/
    /*------ amp styles ---------*/

}
